import { InsightOverview } from '../EntityPages';

export const InsightOverviewTab = () => {
  return <InsightOverview />;
};
